import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, OnChanges, OnInit, ViewChild,} from "@angular/core";
import {ConfirmationService} from "primeng/api";
import {RpReportObjectDto} from "../../../model/dto/entity/rp-report-object.dto";
import {RpReportDto} from "../../../model/dto/entity/rp-report.dto";
import {RpReportObjectLinkDto} from "../../../model/dto/entity/rp-report-object-link.dto";
import {forkJoin, Observable} from "rxjs";
import {RpObjectLinkTypeEnum} from "../../../enum/rp-object-link-type.enum";
import {RpReportSortingDto} from "../../../model/dto/entity/rp-report-sorting.dto";
import {RpReportFilterDto} from "../../../model/dto/entity/rp-report-filter.dto";
import {CcObjectTypeDto} from "../../../model/dto/entity/cc-object-type.dto";
import {RpReportFieldDto} from "../../../model/dto/entity/rp-report-field.dto";
import {LinkTypeDto} from "../../../model/dto/entity/link-type.dto";
import {LinkJoinDto} from "../../../model/dto/entity/link-join.dto";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {MetaDataGenericTypeDto} from "../../../../../core/shared/meta/dto/meta-data-generic-type.dto";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {ObjectRequestSimple} from "../../../../../core/shared/dto/object/request/object-request-simple";
import {DtoList} from "../../../../../core/shared/dto/dto.list";
import {MetaEntityRequestDto} from "../../../../../core/shared/meta/dto/meta-entity-request.dto";
import {MetaDataEntityDto} from "../../../../../core/shared/meta/dto/meta-data-entity.dto";
import {DataTypeHelper} from "../../../../../core/shared/helper/data-type.helper";
import {EntityPriorityHandler} from "../../../../../core/shared/entity/entity-priority-handler";
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {MvsCrudModeEnum} from "../../../../../core/shared/service/crud/mvs-crud-mode.enum";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../core/shared/widget/widget-data-param";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {Sorting} from "../../../../../core/shared/misc/sorting";
import {MetaDataAttributeDto} from "../../../../../core/shared/meta/dto/meta-data-attribute.dto";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {MetaService} from "../../../../../core/shared/meta/service/meta.service";
import {MvsUiObjectService} from "../../../../../core/shared/object/service/mvs-ui-object.service";
import {MvsSortingService} from "../../../../../core/shared/sorting/components/service/mvs-sorting.service";
import {MvsConditionBuilderService} from "../../../../../core/shared/filter/service/mvs-condition-builder.service";
import {ObjectTypeService} from "../../../../../core/cc/service/api/object-type.service";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {MetaDataJoinDto} from "../../../../../core/shared/meta/dto/meta-data-join.dto";
import {Popover} from "primeng/popover";

export interface UiObjectTreeNode {
  startObject: boolean;
  reportObject: RpReportObjectDto;
  reportLink: RpReportObjectLinkDto;
  linkedObjects: UiObjectTreeNode[];

  level: number;
  peerLevel: number;
}

export interface RpReportUiRow {
  columns: RpReportUiColumn[];
}

export interface RpReportUiColumn {
  node: UiObjectTreeNode;
  type: string;
  connectionLine: string;
}
// NOT_IN_USE_CURRENTLY
@Component({
    selector: "mvs-rp-report-object",
    templateUrl: "./rp-report-object.component.html",
    styleUrls: ["./rp-report-object.component.scss"],
    standalone: false
})
export class RpReportObjectComponent
  extends ObjectBaseComponent
  implements OnInit, OnChanges {
    objectTypeAttributeService: MvsCrudService;
  reportFieldService: MvsCrudService;
  reportObjectService: MvsCrudService;
  reportObjectLinkService: MvsCrudService;
  reportFilterService: MvsCrudService;
  reportSortingService: MvsCrudService;

  node: UiObjectTreeNode[] = [];
  treeMaxLevels: number = 0;
  treeMaxPeerLevels: number = 0;

  selectedReportObj: RpReportObjectDto;

  rows: RpReportUiRow[] = [];
  reportDtoId: number;

  dto: RpReportDto;
  linkTypeEnum: typeof RpObjectLinkTypeEnum = RpObjectLinkTypeEnum;

  reportObjectDtoList: DtoList<RpReportObjectDto>;
  reportObjectLinkDtoList: DtoList<RpReportObjectLinkDto>;
  selectedProduct: any;
  products: any;
  attributes: MetaDataAttributeDto[] = [];
  selectedAttribute: MetaDataAttributeDto;

  reportFields: DtoList;

  attributeList: RpReportFieldDto[] = [];
  currentColumn: number;

  previousReportObject: RpReportObjectDto;
  attributesSidebar = false;
  blockedDocument: boolean = false;
  genericTypes: MetaDataGenericTypeDto[] = [];
  selectedGenericType: MetaDataGenericTypeDto;
  linkJoin : LinkJoinDto[] = [
    {
      joinName: 'Main',
      joinTypeId: 0
    },
    {
      joinName: 'Side',
      joinTypeId: 1
    }];

  linkType: LinkTypeDto[] = [
    {
      linkName: 'OneToOne',
      linkTypeId: 0
    },
    {
      linkName: 'OneToMany',
      linkTypeId: 1
    }];

  selectedLinkType: LinkTypeDto;
  selectedLinkJoin: LinkJoinDto;
  testBottomBar: boolean = false;
  reportWidgetData: WidgetData;
  displayLinkModal: boolean = false;
  displayLinkTypeModal: boolean = false;
  reportName: string;
  isMultiple: boolean = true;
  newFilterCriteria: FilterCriteria[] | undefined;
  displayStartObjectModal:boolean = false;
  sortingResponse: Sorting[];
  reportObjectSortingId: number;
  reportFilterId: number;
  objectTypes: DtoList;
  widgetReport: WidgetData;
  showWidgetReportData: boolean = false;
  reportLinkSortingId:number;
  isReportObject:boolean;
  displayGenericTypeModal: boolean = false;

  selectedReportObjectLink: RpReportObjectLinkDto;
  rowIncreased: boolean;

  @ViewChild("joins", { static: true }) joinsPanel: Popover;
  @ViewChild("attributesPanel", { static: true }) attributesPanel: Popover;
  @ViewChild("genericTypesPanel", { static: true }) genericPanel: Popover;
  @ViewChild("joinTypePanel", { static: true }) joinTypePanel: Popover;

  showSidebar: boolean = false;
  selectedUiReportObject: UiObjectTreeNode;
  uiTabIndex: number;

  constructor(
    protected coreService: MvsCoreService,
    protected messageService: MvsMessageService,
    protected confirmationService: ConfirmationService,
    protected metaService: MetaService,
    protected objectService: MvsUiObjectService,
    protected sortingService: MvsSortingService,
    protected conditionBuilderService: MvsConditionBuilderService,
    protected objectTypeService: ObjectTypeService,
    protected override observerService: ObserverService
  ) {
    super(coreService, messageService, confirmationService, observerService);
  }

  ngOnInit() {
    super.ngOnInit();


        this.objectTypeAttributeService = this.coreService.getCrudService("cc.ObjectTypeAttribute");
  }

  initComponent() {
    // retrieve specific service
    this.reportFieldService = <MvsCrudService>(
        this.coreService.getCrudService("rp.ReportField")
    );
    this.reportObjectService = <MvsCrudService>(
        this.coreService.getCrudService("rp.ReportObject")
    );
    this.reportObjectLinkService = <MvsCrudService>(
        this.coreService.getCrudService("rp.ReportObjectLink")
    );
    this.reportFilterService = <MvsCrudService>(
        this.coreService.getCrudService("rp.ReportFilter")
    );

    this.reportSortingService = <MvsCrudService>(
        this.coreService.getCrudService("rp.ReportSorting")
    );

    this.objectTypeAttributeService = <MvsCrudService>this.coreService.getCrudService("cc.ObjectTypeAttribute");
  }


  refreshComponent() {

    // call super implementation
    super.refreshComponent();

    this.refreshReport();

  }

  uiRenderReportTree() {
    // 1) find the start object
    let startObject: RpReportObjectDto;

    for (let entry of this.reportObjectDtoList.entries) {
      if (entry.startObject) {
        startObject = entry;
        break;
      }
    }

    const rootNode = {
      startObject: true,
      reportObject: startObject,
      reportLink: null,
      linkedObjects: [],
      level: 0,
      peerLevel: 0,
    };

    this.node = [];
    this.treeMaxLevels = 0;
    this.treeMaxPeerLevels = 0;

    this.node.push(rootNode);

    // create tree
    this.uiResolveTree(rootNode, 0, 0);

    // convert tree to matrix
    this.uiTreeToMatrix(rootNode);

    //fix matrix structure for null nodes
    this.spliceFirstNullNode(this.rows);
  }

  spliceFirstNullNode(rows) {
    for (const row of rows) {
      for (let i = 1; i < row.columns.length; i++) {
        const currentCell = row.columns[i];
        const previousCell = row.columns[i - 1];
        if (currentCell.node && !previousCell.node && i !== 1) {
          const nullObjectIndex = i - 1;
          if (nullObjectIndex !== 0) {
            row.columns.splice(nullObjectIndex, 1);
          }
        }
      }
    }
  }

  uiTreeToMatrix(node: UiObjectTreeNode) {
    // initialize array
    this.rows = [];

    //treeMaxPeerLevels = rows
    //treeMaxLevels = columns
    for (let i = 0; i <= this.treeMaxPeerLevels; i++) {
      const row: RpReportUiRow = {
        columns: [],
      };

      for (let x = 0; x <= this.treeMaxLevels * 2; x++) {
        row.columns.push({
          node: null,
          type: "",
          connectionLine: ""
        });
      }

      this.rows.push(row);
    }

    this.uiTreeToMatrixResolveNodes(null, node, 0);
  }

  uiTreeToMatrixResolveNodes(parent: UiObjectTreeNode, node: UiObjectTreeNode, childIndex: number) {
    this.uiTreeToMatrixAssignNode(parent, node, childIndex);

    let index = 0;
    for (let linkedObject of node.linkedObjects) {
      this.uiTreeToMatrixResolveNodes(node, linkedObject, index++);
    }
  }

  uiTreeToMatrixAssignNode(parent: UiObjectTreeNode, node: UiObjectTreeNode, childIndex: number) {
    const row = this.rows[node.peerLevel];
    const cell = row.columns[node.level * 2];
    cell.node = node;
    cell.type = "reportObject";

    if (node.level > 0) {
      const cellLink = row.columns[node.level * 2 - 1];
      cellLink.node = node;
      cellLink.type = "link";

      // calculate connection type
      if (parent.linkedObjects.length == 1) {
        cellLink.connectionLine = "main";
      } else {
        // multiple children exist
        if (childIndex == 0) {
          cellLink.connectionLine = "down";
        } else {
          if (parent.linkedObjects.length == childIndex + 1) {
            cellLink.connectionLine = "up";
          } else {
            cellLink.connectionLine = "middle";
          }
        }
      }

    }
  }

  uiResolveTree(
    node: UiObjectTreeNode,
    parentLevel: number,
    peerLevel: number
  ) {

    if (parentLevel > this.treeMaxLevels) {
      this.treeMaxLevels = parentLevel;
    }

    if (peerLevel > this.treeMaxPeerLevels) {
      this.treeMaxPeerLevels = peerLevel;
    }
    // else if (this.rowIncreased) {
    //   this.treeMaxPeerLevels++;
    // }

    // 1) Find children
    let linkedObjects = this.getLinkedObjects(node.reportObject);

    // 2 + 3) add children + call recursively for children
    if (linkedObjects) {
      let peerLevelChild: number = peerLevel;

      // process all links and resolve children
      for (let linkedObject of linkedObjects) {
        let childReportObject=
          this.getReportObjectTargetFromLink(linkedObject);

        // if (this.rowIncreased) {
        //   peerLevelChild++;
        // }

        const childNode = {
          startObject: false,
          reportObject: childReportObject,
          reportLink: linkedObject,
          linkedObjects: [],
          level: parentLevel + 1,
          peerLevel: peerLevelChild,
        };

        node.linkedObjects.push(childNode);

        // if (peerLevelChild > this.treeMaxPeerLevels) {
        //   this.treeMaxPeerLevels = this.treeMaxPeerLevels + 1;
        //   peerLevelChild++;
        // }

        // if (peerLevelChild > peerLevel) {
        //   this.rowIncreased = true;
        // } else {
        //   this.rowIncreased = false;
        // }

        // process children of child
        this.uiResolveTree(childNode, parentLevel + 1, peerLevelChild);
        peerLevelChild++;
      }

    }
  }

  getReportObjectTargetFromLink(
    link: RpReportObjectLinkDto
  ): RpReportObjectDto {

    for (let reportObject of this.reportObjectDtoList.entries) {
      if (link.targetObjectDtoId == reportObject.id) {
        return reportObject;
      }
    }
    return null;
  }

  /**
   * Return all links for a source object.
   * @param sourceObject
   */
  getLinkedObjects(sourceObject: RpReportObjectDto): RpReportObjectLinkDto[] {
    let links: RpReportObjectLinkDto[] = [];

    for (let link of this.reportObjectLinkDtoList.entries) {
      if (link.sourceObjectDtoId === sourceObject.id) {
        links.push(link);
      }
    }
    for (const item of links) {
      if (item.linkJoin == 0) {
        if (item.linkType == this.linkTypeEnum.OneToOne) {
          item.linkTypeLabel = '1:1'
        }
        else {
          item.linkTypeLabel = '1:N'
        }
      }
      else if (item.linkJoin == 1) {
        if (item.linkType == this.linkTypeEnum.OneToOne) {
          item.linkTypeLabel = '1:C'
        }
        else {
          item.linkTypeLabel = '1:CN'
        }
      }

      if (item.linkJoin == 1) {
        item.linkJoinLabel = 'Side'
      }
      else {
        item.linkJoinLabel = 'Main';
      }
    }

    return links;
  }

  refreshReport() {

    if (!this.dto) {
      return;
    }

    this.reportFieldService
        .listByAttribute("report", this.dto.id)
        .subscribe((value) => { });

    const dtoListRequest = new ObjectRequestList(
        false,
        [
          FilterCriteria.create(
              "report",
              FilterCriteria.cOperatorEqual,
              this.dto.id,
              null
          ),
        ],
        null
    );
    dtoListRequest.objectRequestSimple = ObjectRequestSimple.create(true, true,1);

    forkJoin({
      reportObject: this.reportObjectService.listByAttribute(
          "report",
          this.dto.id
      ),
      reportObjectLink: this.reportObjectLinkService.listByAttribute(
          "report",
          this.dto.id
      ),
    }).subscribe(({ reportObject, reportObjectLink }) => {
      if (reportObject && reportObject.entries) {
        this.reportObjectDtoList = <DtoList<RpReportObjectDto>>reportObject;
      }
      if (reportObjectLink && reportObjectLink.entries) {
        this.reportObjectLinkDtoList = <DtoList<RpReportObjectLinkDto>>(
            reportObjectLink
        );
      }
      this.uiRenderReportTree();
    });

    // this.onGetAttributes();

    // this.reportObjectService.listByAttribute("report", this.dto.id).subscribe((value) => {
    //         this.reportObjectDtoList = <DtoList<RpReportObjectDto>>value;

    // this.reportObjectLinkService.listByAttribute("report", this.dto.id).subscribe((value) => {
    //                 this.reportObjectLinkDtoList = <DtoList<RpReportObjectLinkDto>>(value);
    //                 this.uiRenderReportTree();
    //             });
    //     });
    this.blockedDocument = false;
  }

  /**
   * If the report ID changes.
   */
  onObjectChanged() {
    super.onObjectChanged();

    this.refreshReport();

  }

  onGetMetaInfo(obj: UiObjectTreeNode, action: string) {
    this.blockedDocument = true;
    this.selectedGenericType = undefined;
    this.previousReportObject = new RpReportObjectDto();
    this.previousReportObject = obj.reportObject;
    this.reportDtoId = obj.reportObject.reportDtoId;
    this.products = [];
    this.attributes = [];
    this.currentColumn = obj.level;
    this.selectedReportObj = obj.reportObject;
    this.metaService.getById(obj.reportObject.objectTypeDtoId, true, true, true).subscribe((res) => {
      let joins: MetaDataJoinDto[] = res.joins;

      let attributes: MetaDataAttributeDto[] = res.attributes;
      let genericTypeList: MetaDataGenericTypeDto[] = res.genericTypes;



      if (action == 'joins') {
        for (const item of joins) {
          this.products.push(item);
        }
        // this.displayLinkModal = true;
      }

      if (action == 'attributes') {
        if (obj.reportObject.objectGenericTypeId != undefined) {
          for (const item of genericTypeList) {
            if (obj.reportObject.objectGenericTypeId == item.typeId) {
              this.attributes = item.attributes;
            }
          }
        }
        else {
          for (let atr of attributes) {
            let dataType = DataTypeHelper.getInternalDataTypeForFormField(atr);
            atr["icon"] = dataType;
            this.attributes.push(atr);
          }
        }
        // this.attributesPanel.toggle(event);
      }

      this.blockedDocument = false;

    });
  }

  reset() {
    this.selectedProduct = null;
    this.selectedLinkJoin = null;
    this.selectedGenericType = null;
    this.reportName = null;
    this.isMultiple = true;
    this.selectedLinkType = null;
  }

  /**
   * Show widget information whenever the report data should be visible.
   */
  handleToggleReportData() {
    this.blockedDocument = true;
    if (this.showWidgetReportData) {
      this.widgetReport = WidgetFactory.createWidgetEntityData(
          'rp.config.report.view',
          'Report',
          'rp.Report',
          this.objectIdentifier.objectId
      );
    } else {
      this.widgetReport = null;
    }
    this.blockedDocument = false;
  }

  checkIfGeneric() {
    // this.displayLinkTypeModal = true;
    //checking if it is of generic type
    if (this.selectedProduct.genericType == true) {
      this.getGenericTypes();
    }
    else {
      this.genericTypes = [];
      this.reportName = this.selectedProduct.name;
    }
  }

  openJoinTypeOverlay(event: any) {
    this.joinTypePanel.toggle(event.originalEvent);
  }

  onLinkEntity() {

    this.blockedDocument = true;
    let objectGenericTypeId = this.selectedGenericType?.typeId;
    let dto: RpReportObjectDto = new RpReportObjectDto();
        dto.reportDtoId =  this.reportDtoId;
        dto.name = this.reportName;
        dto.startObject = false;
        dto.objectTypeDtoId = this.selectedProduct.joinObjectTypeId;
        dto.objectGenericTypeId = objectGenericTypeId;
    this.reportObjectService.create(dto).subscribe((res:RpReportObjectDto) => {
      this.getReportLinkObject(res);
    });
  }

  getGenericTypes() {
    this.blockedDocument = true;
    this.metaService.getByAlias(this.selectedProduct.joinObjectTypeAlias, true, true, true).subscribe(res => {
      const obj : MetaDataGenericTypeDto = new MetaDataGenericTypeDto();
        obj.typeId = null;
        obj.typeName = this.selectedProduct.name;
      this.genericTypes = res.genericTypes;
      for (const item of this.genericTypes) {
        item.typeName = this.selectedProduct.name + ' - ' + item.typeName
      }

      this.genericTypes.unshift(obj);
      this.displayGenericTypeModal = true;
      this.blockedDocument = false;
    })
  }

  getReportLinkObject(obj: RpReportObjectDto) {
    let dto: RpReportObjectLinkDto = new RpReportObjectLinkDto();
        dto.reportDtoId =  obj.reportDtoId;
        dto.reportObjectDtoId =  this.previousReportObject.id;
        dto.linkType =  this.selectedProduct.joinRelationEnum == 'oneToOne' ? 0  :  this.selectedLinkType.linkTypeId;
        dto.linkJoin =  this.selectedLinkJoin.joinTypeId;
        dto.linkAttribute =  this.selectedProduct.attributeName;
        dto.sourceObjectDtoId =  this.previousReportObject.id;
        dto.targetObjectDtoId =  obj.id;
        dto.name =  this.selectedProduct.name;
        dto.priority =  this.currentColumn + 1;
        dto.multiple =  this.selectedProduct.joinRelationEnum == 'oneToOne' ? false  :  this.isMultiple;
        dto.optional = false;

    this.reportObjectLinkService.create(dto).subscribe((res) => {
      this.refreshReport();
      this.reset();
      this.displayGenericTypeModal = false;
      this.displayLinkModal = false;
      this.displayLinkTypeModal = false;
      this.blockedDocument = false;
    });
  }

  onConfirmDeleteLink(event: Event, ReportObjectID: number, ReportObjectLinkID: number) {

    this.confirmationService.confirm({
      target: event.target,
      message: 'Are you sure that you want to delete?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteReportObjectLink(ReportObjectID, ReportObjectLinkID);
      },
      reject: () => {
      },
    });
  }

  deleteReportObjectLink(ReportObjectID: number, ReportObjectLinkID: number) {

    this.blockedDocument = true;
    this.reportObjectLinkService.delete(ReportObjectLinkID).subscribe(res => {
      this.deleteReportObject(ReportObjectID);

    })
  }

  deleteReportObject(id: number) {
    this.reportObjectService.delete(id).subscribe(res => {
      this.refreshReport();
      this.blockedDocument = false;
    })
  }



  onAddAttributestoField(event: any) {

    this.blockedDocument = true;
    let priority = (this.attributeList.length);
    let dto: RpReportFieldDto = new RpReportFieldDto();

        dto.reportDtoId =  this.selectedReportObj.reportDtoId;
        dto.reportObjectDtoId =  this.selectedReportObj.id;
        dto.attributeName =  this.selectedAttribute.attributeName;
        dto.priority =  (priority + 1) * 10000;
        dto.name =  this.selectedAttribute.label;

    this.reportFieldService.create(dto).subscribe(res => {
      this.attributesPanel.toggle(event);
      this.attributesSidebar = false;
      this.onGetAttributes();
    })
  }
  onGetAttributes() {
    this.attributesSidebar = !this.attributesSidebar;
    if(this.attributesSidebar){
      this.blockedDocument = true;
      const filterCriteriaList = [];
      filterCriteriaList.push(FilterCriteria.createSingleCondition('report', FilterCriteria.cOperatorEqual, this.dto.id, null));

      const dtoListRequest = new ObjectRequestList(false, filterCriteriaList, [new Sorting('priority', true)]);

      dtoListRequest.objectRequestSimple = ObjectRequestSimple.create(true, true,1);
      this.reportFieldService.list(dtoListRequest).subscribe((res:DtoList<RpReportFieldDto>) => {
        this.attributeList = [];

        for (const item of res.entries) {
          // TODO
          // let dataType = this.MvsFilterHelperService.handleDataType(item);
          // item["icon"] = dataType;
          this.attributeList.push(item);
        }
        this.retrieveDataTypesForAttributeList(this.attributeList);

        this.blockedDocument = false;
      })
    }

    // retrieve data types

    // this.reportFieldService.delete();
  }

  //TODO: Haris, please finalize the implementation.
  /**
   * Retrieve attribute types based on selected attributes.
   * @param attributeList
   */
  retrieveDataTypesForAttributeList(attributeList: RpReportFieldDto[]) {

    const reportObjectIds = Array.from(new Set(attributeList.map(attr => attr.reportObjectDtoId)));
    const filteredReportObjects = this.reportObjectDtoList.entries.filter(reportObj => reportObjectIds.includes(reportObj.id));
    const objectTypeDtoIds = Array.from(new Set(filteredReportObjects.map(attr => attr.objectTypeDtoId)));

    const dtoListRequest = new MetaEntityRequestDto();
    dtoListRequest.listByIds = objectTypeDtoIds;
    dtoListRequest.extractAttributes = true;
    dtoListRequest.extractJoins = false;

    let metaAttributes: MetaDataEntityDto[];
    this.metaService.list(dtoListRequest).subscribe(res =>{
      metaAttributes = res.entities;

      // 1) Retrieve Object Types via the ReportObject

      for (let attribute of attributeList) {

        for (let entry of this.reportObjectDtoList.entries) {
          if (attribute.reportObjectDtoId == entry.id) {
            let reportObjectAttributes = metaAttributes.find(item => item.objectTypeId == entry.objectTypeDtoId).attributes;
            for (let element of reportObjectAttributes) {
              if(element.attributeName == attribute.attributeName){
                attribute["icon"] = DataTypeHelper.getInternalDataTypeForFormField(element);
              }
            }
          }
        }

      }
    })

    // 2) Use MetaService to retrieve the Attributes of the Object Types (run the meta service only once per object type)

    // 3) Map the retrieved Object Types and Attributes against the Attribute List


  }


  deleteAttribute(id: number) {

    this.blockedDocument = true;
    this.reportFieldService.delete(id).subscribe(res => {
      this.refreshReport();
      if (this.testBottomBar) {
        this.checkTest();
      }
    })
  }

  changeAttributePriority() {

    this.blockedDocument = true;
    let operations = EntityPriorityHandler.adjustPriority(this.attributeList, "priority", 1000);
    let updatedArray = [];
    for (const item of operations) {
      updatedArray.push(item.entry);
    }

    const entryObservables: Observable<any>[] = updatedArray.map(entry => {
      return this.reportFieldService.update(entry);
    });

    forkJoin(entryObservables).subscribe(value => {
    });
    this.blockedDocument = false;
  }

  onConfirmDeleteAttribute(id: number) {

    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this attribute?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteAttribute(id)
      },
      reject: () => {
      },
    });
  }

  onEditAttributesField(id: number) {
    this.objectService.openObjectViaDialog(
      new DtoImportObjectContext([]),
      "rp.ReportField",
      id,
      null,
      false,
      false,
      () => {
        this.onGetAttributes();
      },
        MvsCrudModeEnum.create
    );
  }
  checkTest() {
    this.testBottomBar = !this.testBottomBar;
    if (this.testBottomBar) {
      const dataProviderListRequest = new ObjectRequestList(true,[],[]);
      this.reportWidgetData = WidgetFactory.createReportWidget(
          'ReportEditor.TestReport',
          'Test Report',
          this.dto.id + "",
          'No Record Found.',
          dataProviderListRequest,
          WidgetDataParam.create("size", "M")
      );
    }
  }

  onEditReportObjectName(item: RpReportObjectDto) {
    item.edit = false;
    let dto: RpReportObjectDto = new RpReportObjectDto();
    dto.id = item.id;
    dto.name = item.name;
    this.reportObjectService.update(dto).subscribe(res => {
    })

  }

  updateLinkRecords() {
    if (this.selectedLinkType.linkTypeId == 0) {
      this.isMultiple = false;
    }
    else {
      this.isMultiple = true;
    }
  }



  createReportFilter(reportObject: RpReportObjectDto, json) {

    const dto: RpReportFilterDto = new RpReportFilterDto();
    dto.name = reportObject.name;
    dto.filterJson = JSON.stringify(json);
    dto.sourceObjectTypeDtoId = reportObject.objectTypeDtoId;

    this.reportFilterService.create(dto).subscribe(res => {
      this.updateReportObjectFilter(reportObject.id, res);
    })
  }


  getReportObjectFilter(reportObject: RpReportObjectDto) {

    //TODO: newFilterCriteria must be part of the method
    if (!reportObject.reportFilterDtoId) {
      // no filter was defined yet
      this.newFilterCriteria = undefined;
      this.onShowCbViaId(reportObject);
      return;
    }

    // retrieve filter
    const dtoListRequest = new ObjectRequestList(false, [
      FilterCriteria.create(
        "id",
        FilterCriteria.cOperatorEqual,
        reportObject.reportFilterDtoId,
        null
      ),
    ], []);
    this.reportFilterService.list(dtoListRequest).subscribe((res: DtoList<RpReportFilterDto>) => {

      let filterObject = res.entries[0];

      if (filterObject) {
        this.newFilterCriteria = JSON.parse(filterObject.filterJson);
        this.reportFilterId = filterObject.id;
      }
      else {
        this.newFilterCriteria = undefined;
      }
      this.onShowCbViaId(reportObject);
    })
  }



  updateReportObjectFilter(reportObjectId: number, value: DtoDetail) {

    let dto : RpReportObjectDto = new RpReportObjectDto();
    dto.id = reportObjectId;
    dto.reportFilterDtoId = value.id;

    this.reportObjectService.update(dto).subscribe(res => {
      this.refreshReport();
    })
  }

  saveFilterJSON(response, reportObject: RpReportObjectDto) {

    if (!reportObject.reportFilterDtoId) {
      this.createReportFilter(reportObject, response);
    }
    else {
      this.updateReportFilter(response);
    }
  }


  updateReportLinkSorting(json) {

    let dto: RpReportSortingDto = new RpReportSortingDto();
    dto.id = this.reportLinkSortingId;
    dto.sortingJson = JSON.stringify(json);

    this.reportSortingService.update(dto).subscribe(res => {
    });
  }

  updateReportFilter(json) {

    let dto: RpReportFilterDto = new RpReportFilterDto();
    dto.id = this.reportFilterId;
    dto.filterJson = JSON.stringify(json);

    this.reportFilterService.update(dto).subscribe(res => {
    })
  }



  removeFilterReportObject(reportObjectId: number) {

    let dto: RpReportObjectDto = new RpReportObjectDto();
    dto.id = reportObjectId;
    dto.reportFilterDtoId = null;

    this.reportObjectService.update(dto).subscribe(res => {
      this.deleteFilter();
    });
  }

  deleteFilter() {

    this.reportFilterService.delete(this.reportFilterId).subscribe(res => {
      this.refreshReport();
    })
  }


  onShowFilter(reportObject: RpReportObjectDto) {

    this.getReportObjectFilter(reportObject);
  }

  onShowLinkedFilter(reportObjectLink: RpReportObjectLinkDto) {
    let reportObject: RpReportObjectDto = this.reportObjectDtoList.entries.find(item => item.id == reportObjectLink.targetObjectDtoId);
    this.onShowFilter(reportObject);
  }

  exposeDialog(reportObject: RpReportObjectDto) {

    this.sortingService.showSortingEntityDialog(
      this.sortingResponse,
      reportObject.objectTypeDtoId,
      false,
      (sorting: Sorting[]) => {this.saveSortingJSON(sorting, reportObject);
        return true},
      (sorting: Sorting[]) => {
      return true},
      (sorting: Sorting[]) => {this.removeSortingReportObject(reportObject.id);
      return true},
      (sorting: Sorting[]) => {this.saveSortingJSON(sorting, reportObject);
      return true}
    );
  }

  onShowCbViaId(reportObject: RpReportObjectDto) {

    this.conditionBuilderService.showConditionBuilderEntityDialog(
      this.newFilterCriteria,
      reportObject.objectTypeDtoId,
      null,
      false,
      (filterCriteria: FilterCriteria[]) => {this.saveFilterJSON(filterCriteria,reportObject);
      return true},
        (filterCriteria: FilterCriteria[]) => {
          return true},
        (filterCriteria: FilterCriteria[]) => {this.removeFilterReportObject(reportObject.id)
          return true}
    );
  }

  onViewAllObjectTypes(){
    if(this.objectTypes == undefined){
    this.blockedDocument = true;
    this.objectTypeService.list(ObjectRequestList.createSimple(null)).subscribe(value => {
      this.objectTypes = value;
      this.objectTypes.sortBy("alias", true);
      this.initialized = true;
      this.blockedDocument = false;
      this.displayStartObjectModal = true;
    });
    }
    else{
      this.displayStartObjectModal = true;
    }
  }

  // sorting create functions
  onCreateStartObject(type: CcObjectTypeDto){
    this.blockedDocument = true;
    let dto: RpReportObjectDto = new RpReportObjectDto();
        dto.reportDtoId =  this.dto.id;
        dto.name = type.name;
        dto.startObject = true;
        dto.objectTypeDtoId = type.id;

    this.reportObjectService.create(dto).subscribe((res) => {
      this.displayStartObjectModal = false;
      this.refreshReport();

    });
  }

  onShowSortings(reportObject: RpReportObjectDto, isReportObject:boolean) {

    this.isReportObject = isReportObject;
    //check for previous sortings if available
    this.getReportObjectSorting(reportObject);
  }

  getReportObjectSorting(reportObject: RpReportObjectDto) {

    // sorting does not exist yet
    if (!reportObject.reportSortingDtoId) {
      this.sortingResponse = undefined;
      this.exposeDialog(reportObject);
      return;
    }

    const dtoListRequest = new ObjectRequestList(false, [
      FilterCriteria.create(
          "id",
          FilterCriteria.cOperatorEqual,
          reportObject.reportSortingDtoId,
          null
      ),
    ], []);
    this.reportSortingService.list(dtoListRequest).subscribe((res:DtoList<RpReportSortingDto>) => {
      this.sortingResponse = [];
      let sortingObject = res.entries[0];
      if (sortingObject) {
        this.sortingResponse = JSON.parse(sortingObject.sortingJson);
        if(this.isReportObject){
          this.reportObjectSortingId = sortingObject.id;
        }
        else if (!this.isReportObject){
          this.reportLinkSortingId = sortingObject.id;
        }
      }
      else {
        this.sortingResponse = undefined;
      }
      this.exposeDialog(reportObject);
    })
  }

  saveSortingJSON(response, reportObject: RpReportObjectDto) {

    this.blockedDocument = true;
    //if sorting is for report object
    if(this.isReportObject){
      this.saveReportObjectSorting(response,reportObject);
    }
    //if sorting is for report link
    else if(!this.isReportObject){
      this.saveReportObjectLinkSorting(response,reportObject);
    }
  }

  saveReportObjectSorting(response, reportObject: RpReportObjectDto){
    //check if no sorting exists then create new
    if (!reportObject.reportSortingDtoId) {
      this.createReportSorting(reportObject, response);
    }
    //check if sorting exists then just update it
    else {
      this.updateReportSorting(response);
    }
  }

  createReportSorting(reportObject: RpReportObjectDto, json) {
    const dto: RpReportSortingDto = new RpReportSortingDto();
    dto.name = reportObject.name;
    dto.sortingJson = JSON.stringify(json);
    dto.sourceObjectTypeDtoId = reportObject.objectTypeDtoId;

    this.reportSortingService.create(dto).subscribe((res: DtoDetail) => {
      //once sorting is created, update the report object
      this.updateReportObjectSorting(reportObject.id, res);

    })
  }

  updateReportObjectSorting(reportObjectId: number, value: DtoDetail) {
    let dto : RpReportObjectDto = new RpReportObjectDto();
    dto.id = reportObjectId;
    dto.reportSortingDtoId = value.id;

    this.reportObjectService.update(dto).subscribe(res => {
      this.refreshReport();
    })
  }


  //sorting update function
  updateReportSorting(json) {

    let dto: RpReportSortingDto = new RpReportSortingDto();
    dto.id = this.reportObjectSortingId;
    dto.sortingJson = JSON.stringify(json);

    this.reportSortingService.update(dto).subscribe(res => {
      this.blockedDocument = false;
    });
  }

  //sorting delete functions
  removeSortingReportObject(reportObjectId: number) {
    //first remove the reportSortingDtoId from the report object
    this.blockedDocument = true;
    let dto: RpReportObjectDto = new RpReportObjectDto();
    dto.id = reportObjectId;
    dto.reportSortingDtoId = null;

    this.reportObjectService.update(dto).subscribe(res => {
      //once reportObject is done, delete the sorting itself
      this.deleteSorting();
    })
  }

  deleteSorting() {
    this.reportSortingService.delete(this.reportObjectSortingId).subscribe(res => {
      this.refreshReport();
    })
  }

  //report link sorting functions
  onShowLinkedSortings(reportObjectLink: RpReportObjectLinkDto) {

    let reportObject: RpReportObjectDto = this.reportObjectDtoList.entries.find(item => item.id == reportObjectLink.targetObjectDtoId);
    this.selectedReportObjectLink = reportObjectLink;
    this.onShowSortings(reportObject,false);
  }

  updateReportObjectLinkSorting(reportObjectLinkId: number, value: DtoDetail){
    let dto : RpReportObjectLinkDto = new RpReportObjectLinkDto();
    dto.id = reportObjectLinkId;
    dto.reportSortingDtoId = value.id;

    this.reportObjectLinkService.update(dto).subscribe(res => {
      this.selectedReportObjectLink = null;
      this.isReportObject = null;
      this.refreshReport();
    })
  }

  saveReportObjectLinkSorting(response, reportObject: RpReportObjectDto){

    if(!this.selectedReportObjectLink.reportSortingDtoId){
      this.createReportSorting(reportObject, response);
    }
    else{
      this.updateReportLinkSorting(response);
    }
  }

  handleSetSidebar(object: UiObjectTreeNode){

    this.showSidebar = true;

    this.selectedUiReportObject = object;

    if (this.uiTabIndex) {
    this.handleLoadSideBarMetaInfo(this.uiTabIndex);
    } else {
      this.uiTabIndex = 0;
    }
  }

  handleLoadSideBarMetaInfo(event: number | string){

    this.uiTabIndex = event as number;
    if (this.uiTabIndex == 2) {
      this.onGetMetaInfo(this.selectedUiReportObject,'attributes');
    } else if (this.uiTabIndex == 3) {
      this.onGetMetaInfo(this.selectedUiReportObject,'joins');
    }

  }

  onResetJoins() {
    this.selectedProduct =  null;
  }

}

